import { connect } from "react-redux";
import PremierPageFrame from "../../components/PremierPageFrame/index.jsx";

const mapStateToProps = (state) => ({
  countriesData: state.PremierSelectorOptions.countriesData,
  countryData: state.CountrySelector.countryData,
  modalVisible: state.Modal.termsAndConditionsModalVisible,
  content: state.PremierPageFrame.content,
  apiError: state.CountrySelector.apiError,
  errorMessage: state.PremierPageFrame.errorMessage,
  error: state.PremierSelectorOptions.error,
  payload: state.PremierSelectorOptions.payload,
  offeredFreeTrial: state.PremierPageFrame.offeredFreeTrial,
  firstName: state.PremierPageFrame.firstName,
});

export default connect(mapStateToProps)(PremierPageFrame);
